// actionTypes.js

// Fetch courses
export const FETCH_COURSES_REQUEST = 'FETCH_COURSES_REQUEST';
export const FETCH_COURSES_SUCCESS = 'FETCH_COURSES_SUCCESS';
export const FETCH_COURSES_FAILURE = 'FETCH_COURSES_FAILURE';


// Add course
export const ADD_COURSE_REQUEST = 'ADD_COURSE_REQUEST';
export const ADD_COURSE_SUCCESS = 'ADD_COURSE_SUCCESS';
export const ADD_COURSE_FAILURE = 'ADD_COURSE_FAILURE';

// Update course
export const UPDATE_COURSE_REQUEST = 'UPDATE_COURSE_REQUEST';
export const UPDATE_COURSE_SUCCESS = 'UPDATE_COURSE_SUCCESS';
export const UPDATE_COURSE_FAILURE = 'UPDATE_COURSE_FAILURE';

// Delete course
export const DELETE_COURSE_REQUEST = 'DELETE_COURSE_REQUEST';
export const DELETE_COURSE_SUCCESS = 'DELETE_COURSE_SUCCESS';
export const DELETE_COURSE_FAILURE = 'DELETE_COURSE_FAILURE';

// Fetch courses dropdown
export const FETCH_COURSES_DROPDOWN_REQUEST = 'FETCH_COURSES_DROPDOWN_REQUEST';
export const FETCH_COURSES_DROPDOWN_SUCCESS = 'FETCH_COURSES_DROPDOWN_SUCCESS';
export const FETCH_COURSES_DROPDOWN_FAILURE = 'FETCH_COURSES_DROPDOWN_FAILURE';
